import { APIService } from "../../../../network/api/APIService"

export const OrdersData = ({ pageFilters }) => {

    let baseEndpoint = `/shop/api/orders/`;


    const filtersQuery = Object.entries(pageFilters)
        .filter(([_, value]) => value !== null && value !== "")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    const endpoint = `${baseEndpoint}${filtersQuery ? `?${filtersQuery}` : ""}`;

    const config = {
        endpoint: endpoint,
        method: "GET",
        credentials: "include",
    };

    return APIService(config);
}